import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData, trueFalseToBoolean } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelineChangeVendorModel
    //action
    , resetWirelineChangeVendorForm
    , setVendorOptions
    , setAccountOptions
    , setVendorDetails
    , setSubscriptionDetails
    , setFormSubmitted
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-change-vendor.settings';

export const changeVendorModelAInitialState = wirelineChangeVendorModel;

const defaultState = () => ({
    accountOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , vendorDetails: {
        Currency: ''
    }
    , subscription: {}
    , formSubmitted: false
});

const initialState = defaultState();


export const wirelineChangeVendorActions = {
    onSubscriptionSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineChangeVendorFormA } = state().form;

        if (value === '') {
            resetForm(dispatch);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CircuitId != wirelineChangeVendorFormA.circuitId) {
                resetForm(dispatch);
                dispatch(actions.change('wirelineChangeVendorFormA.circuitCode', value));
                dispatch(actions.change('wirelineChangeVendorFormA.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
                getVendors(dispatch, obj);
            }
        }
    }
    , onVendorSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineChangeVendorFormA.financeAccountId', 0));

        //Clear options
        dispatch({ type: setAccountOptions, data: [] });
        dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });

        //fetch new data options
        getAccounts(dispatch, value);
    }
    , onEmployeeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelessChangeUserFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineChangeVendorFormA.employeeEmail', ''));
            dispatch(actions.change('wirelineChangeVendorFormA.wireLineApproverId', 0));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.EmployeeId != wirelessChangeUserFormA.employeeId) {
                dispatch(actions.change('wirelineChangeVendorFormA.employeeEmail', value));
                dispatch(actions.change('wirelineChangeVendorFormA.wireLineApproverId', obj.EmployeeId));
            }
        }
    }
    , onChangeExpedite: (model, value) => (dispatch) => {

        dispatch(actions.change(model, value));

        if (!trueFalseToBoolean(value)) {
            dispatch(actions.change('wirelineChangeVendorFormA.businessJustification', ''));
        }
    }
    , submitRequest: (date) => async (dispatch, state) => {

        const { wirelineChangeVendorFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }

        var data = {
            ...userData
            , requestTypeId: requestTypeId
            , wirelineChangeVendorRequest: {
                ...wirelineChangeVendorFormA
                , requestInBehalfId: userData.requestInBehalfId
                , needDate: date
            }
        }

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/wirelineOrderRequest', data);

        if (!(res || res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelineChangeVendorForm: () => (dispatch) => {
        resetForm(dispatch);
    }
}

async function getAccounts(dispatch, id) {
    var res = await httpGet('external/orderRequest/getAccountByVendor/' + id);

    if (res != null) {
        dispatch({ type: setAccountOptions, data: res });
    } else {
        dispatch({ type: setAccountOptions, data: [] });
    }
}

async function getVendors(dispatch, obj) {
    if (obj === undefined || obj == null) return;

    var res = await httpGet('external/changeVendor/getVendors/'
        + obj.CircuitId + '/'
        + obj.Country + '/'
        + obj.VendorDetailId);

    if (res != null && res.ok !== false) {
        dispatch({ type: setVendorOptions, prefVendors: res.PrefVendors, nonPrefVendors: res.NonPrefVendors });
    } else {
        dispatch({ type: setVendorOptions, prefVendors: [], nonPrefVendors: [] });
    }
}

function resetForm(dispatch) {
    
    dispatch(actions.reset('wirelineChangeVendorFormA'));
    dispatch({ type: resetWirelineChangeVendorForm, vendor: defaultState.vendorDetails });
    dispatch({ type: setFormSubmitted, data: false });
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case resetWirelineChangeVendorForm:
            return {
                ...state,
                accountOptions: []
                , preferredVendorOptions: []
                , nonPrefVendorOptions: []
                , vendorDetails: { ...action.vendor }
            };
        case setVendorOptions:
            return {
                ...state
                , preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setAccountOptions:
            return {
                ...state
                , accountOptions: action.data
            };
        case setVendorDetails:
            return {
                ...state
                , vendorDetails: { ...action.data }
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };

        default: return state;
    }
}